<ng-container *ngIf="vm$ | async as vm">
	<div
		class="grid gap-6"
		data-intercom-target="closer-sync-prompts"
		[ngClass]="
			vm.mortgage?.transactionType === TransactionType.BRIDGE
				? 'grid-cols-1'
				: 'grid-cols-2'
		"
	>
		<!-- REQUEST FOR FUNDS STATUS CARD -->
		<ng-container *ngIf="vm.rffPackageStatus as rff">
			<div
				class="p-2 rounded-xl bg-white border flex gap-4"
				[ngClass]="vm.hasForms ? 'min-h-56' : 'min-h-52'"
			>
				<ng-container *ngIf="vm.syncFlowType !== SYNC_FLOW_TYPES.EMAIL">
					<div
						class="basis-4/12 rounded-lg bg-orange-50 p-4 flex items-center"
						[ngClass]="{
							'bg-orange-50': rff.displayStatus === STATUSES.ACTIONS_REQUIRED,
							'bg-green-50': rff.displayStatus === STATUSES.RECIEVED_BY_LENDER,
							'bg-gray-50':
								rff.displayStatus !== STATUSES.ACTIONS_REQUIRED &&
								rff.displayStatus !== STATUSES.RECIEVED_BY_LENDER,
							'basis-4/12':
								vm.mortgage?.transactionType !== TransactionType.BRIDGE,
							'basis-2/12':
								vm.mortgage?.transactionType === TransactionType.BRIDGE,
						}"
					>
						<img
							[src]="
								'/assets/images/mortgage/request-for-funds' +
								(rff.displayStatus !== STATUSES.ACTIONS_REQUIRED
									? '-ready'
									: '') +
								'.svg'
							"
						/>
					</div>
					<div
						class="basis-8/12 p-4 pl-0 flex flex-col gap-4"
						[ngClass]="{
							'basis-8/12':
								vm?.mortgage?.transactionType !== TransactionType.BRIDGE,
							'basis-10/12':
								vm?.mortgage?.transactionType === TransactionType.BRIDGE,
						}"
					>
						<div class="pb-4 border-b flex gap-4 justify-between">
							<h5 class="h5">Request For Funds</h5>
							<ui-status [status]="rff.displayStatus"></ui-status>
						</div>

						<ng-container [ngSwitch]="rff.status">
							<ng-container *ngSwitchCase="PACKAGE_STATUS_TYPES.PREPARE">
								<p class="p-sm">
									Complete missing funding information to review & send your
									Request For Funds.
								</p>
								<ui-anchor
									(click)="goto($event, DetailNavType.MORTGAGE_DETAILS)"
								>
									Go to Funding Options
								</ui-anchor>
							</ng-container>

							<ng-container *ngSwitchCase="PACKAGE_STATUS_TYPES.SENDING">
								<p class="p-sm">Your Request for Funds is on it's way!</p>
								<ui-anchor (click)="gotoHistory($event)">
									View package status
								</ui-anchor>
							</ng-container>

							<ng-container *ngSwitchCase="PACKAGE_STATUS_TYPES.REVIEW">
								<p class="p-sm">
									Review your Request For Funds and attach additional documents
									to send to the lender.
								</p>
								<ui-anchor (click)="gotoRff($event)"> Review & Send </ui-anchor>
							</ng-container>

							<ng-container *ngSwitchCase="PACKAGE_STATUS_TYPES.SENT">
								<p class="p-sm">
									Your Request For Funds was
									<span class="font-medium"
										>sent on {{ rff.createdAt | closerDate }}</span
									>. The status will update to “Received” once Sync has
									confirmed receipt with the lender.
								</p>
								<div class="flex gap-2 items-center">
									<ui-anchor (click)="gotoHistory($event)"
										>View history</ui-anchor
									>
									<span class="p-sm">or</span>
									<ui-anchor (click)="gotoRff($event, true)">Resend</ui-anchor>
								</div>
								<ng-container *ngTemplateOutlet="fundsReceived"></ng-container>
							</ng-container>

							<ng-container *ngSwitchCase="PACKAGE_STATUS_TYPES.CONFIRMED">
								<p class="p-sm">
									Your Request For Funds was
									<span class="font-medium"
										>sent on {{ rff.createdAt | closerDate }}</span
									>. It has been received by the lender.
								</p>
								<div class="flex gap-2 items-center">
									<ui-anchor (click)="gotoHistory($event)"
										>View history</ui-anchor
									>
									<span class="p-sm">or</span>
									<ui-anchor (click)="gotoRff($event, true)">Resend</ui-anchor>
								</div>
								<ng-container *ngTemplateOutlet="fundsReceived"></ng-container>
							</ng-container>
						</ng-container>
					</div>
				</ng-container>
				<ng-container *ngIf="vm.syncFlowType === SYNC_FLOW_TYPES.EMAIL">
					<div
						class="basis-4/12 rounded-lg bg-gray-50 p-4 flex items-center"
						[ngClass]="{
							'bg-orange-50':
								rff.displayStatus === STATUSES.ACTIONS_REQUIRED && vm.hasForms,
							'bg-gray-50':
								rff.displayStatus !== STATUSES.ACTIONS_REQUIRED || !vm.hasForms,
						}"
					>
						<img
							[src]="
								'/assets/images/mortgage/request-for-funds' +
								(rff.displayStatus !== STATUSES.ACTIONS_REQUIRED || !vm.hasForms
									? '-ready'
									: '') +
								'.svg'
							"
						/>
					</div>

					<div class="basis-8/12 p-4 pl-0 flex flex-col gap-4">
						<div class="pb-4 border-b flex gap-4 justify-start">
							<h5 class="h5">Request For Funds</h5>
							<ui-status
								[status]="rff.displayStatus"
								*ngIf="
									rff.status === PACKAGE_STATUS_TYPES.PREPARE && vm.hasForms
								"
							></ui-status>
						</div>

						<ng-container
							*ngIf="
								rff.status === PACKAGE_STATUS_TYPES.PREPARE && vm.hasForms;
								else rffNonPrepareCards
							"
						>
							<p class="p-sm">
								Complete missing funding information to review & download your
								Request your Funds.
							</p>
							<ui-anchor (click)="goto($event, DetailNavType.MORTGAGE_DETAILS)">
								Go to Funding Options
							</ui-anchor>
						</ng-container>

						<ng-template #rffNonPrepareCards>
							<ng-container *ngIf="!vm.mortgage.isRffEmailSent">
								<p class="p-sm">
									{{ vm.hasForms ? 'Download' : 'Complete' }} your Request For
									Funds and additional documents and
									{{ vm.rffTransmissionType }} them to
									<ng-container [ngSwitch]="vm.rffTransmissionType">
										<span
											*ngSwitchCase="'fax'"
											[ngClass]="{
												'font-bold': vm.rffTransmissionType === 'fax',
												underline:
													vm.rffTransmissionType === 'email' &&
													(vm.mortgage?.lenderContactEmail ||
														vm.mortgage?.rffEmail ||
														vm.primaryLender?.requestForFundsContact?.email),
											}"
											>{{ vm.rffTransmissionText }}</span
										>
										<ng-container *ngSwitchCase="'email'">
											<ng-container
												[ngTemplateOutlet]="emailLink"
												[ngTemplateOutletContext]="{
													link: {
														href: vm.rffTransmissionLink,
														text: vm.rffTransmissionText,
													},
												}"
												*ngIf="
													vm.mortgage?.lenderContactEmail ||
														vm.mortgage?.rffEmail ||
														vm.primaryLender?.requestForFundsContact?.email;
													else noEmailSet
												"
											></ng-container>
											<ng-template #noEmailSet>
												<span>
													{{ vm.rffTransmissionText }}
												</span>
											</ng-template>
										</ng-container>
										<span *ngSwitchDefault>{{ vm.rffTransmissionText }}</span>
									</ng-container>
								</p>
								<ui-anchor (click)="gotoRff($event)" *ngIf="vm.hasForms">
									Review & Download
								</ui-anchor>
							</ng-container>
							<ng-container *ngIf="!!vm.mortgage.isRffEmailSent">
								<p class="p-sm">
									{{ vm.mortgage?.isRffEmailSent?.confirmedBy?.name }} confirmed
									the Request for Funds was
									{{ vm.rffTransmissionTypePastTense }}
									{{ vm.mortgage.isRffEmailSent.date | closerDate }}.
								</p>
							</ng-container>

							<app-checkbox
								type="clear"
								label="I have {{
									vm.rffTransmissionTypePastTense
								}} the Request for Funds"
								[ngModel]="!!vm.mortgage.isRffEmailSent"
								(ngModelChange)="onRffEmailSentChange($event)"
							></app-checkbox>
							<p *ngIf="vm.mortgage?.isRffEmailSent" class="p-xs">
								Confirmed by
								{{ vm.mortgage?.isRffEmailSent?.confirmedBy?.name }}
								{{ vm.mortgage?.isRffEmailSent?.date | closerDate }}
							</p>

							<ng-container
								*ngIf="!!vm.mortgage?.isRffEmailSent"
								[ngTemplateOutlet]="fundsReceived"
							>
							</ng-container>
						</ng-template>
					</div>
				</ng-container>
			</div>
		</ng-container>

		<ng-template #fundsReceived>
			<app-checkbox
				type="clear"
				label="I have received funds and/or funding confirmation"
				[ngModel]="!!vm.fundsReceived"
				(ngModelChange)="onRffSentChange($event)"
			></app-checkbox>
			<div class="h-4">
				<p *ngIf="vm.fundsReceived" class="p-xs">
					Confirmed by {{ vm.fundsReceived?.confirmedBy?.name }}
					{{ vm.fundsReceived?.date | closerDate }}
				</p>
			</div>
		</ng-template>

		<!-- FINAL REPORT STATUS CARD -->
		<ng-container
			*ngIf="vm.mortgage?.transactionType !== TransactionType.BRIDGE"
		>
			<ng-container *ngIf="vm.syncFlowType !== SYNC_FLOW_TYPES.EMAIL">
				<ng-container *ngIf="vm.frPackageStatus as fr">
					<div class="p-2 rounded-xl bg-white border flex gap-4 min-h-56">
						<div
							class="basis-4/12 rounded-lg bg-orange-50 p-4 flex items-center"
							[ngClass]="{
								'bg-orange-50': fr.displayStatus === STATUSES.ACTIONS_REQUIRED,
								'bg-green-50': fr.displayStatus === STATUSES.RECIEVED_BY_LENDER,
								'bg-gray-50':
									fr.displayStatus !== STATUSES.ACTIONS_REQUIRED &&
									fr.displayStatus !== STATUSES.RECIEVED_BY_LENDER,
							}"
						>
							<img
								[src]="
									'/assets/images/mortgage/final-report' +
									(fr.displayStatus !== STATUSES.ACTIONS_REQUIRED
										? '-ready'
										: '') +
									'.svg'
								"
							/>
						</div>
						<div class="basis-8/12 p-4 pl-0 flex flex-col gap-4">
							<div class="pb-4 border-b flex gap-4 justify-between">
								<h5 class="h5">Final Report</h5>
								<ui-status [status]="fr.displayStatus"></ui-status>
							</div>

							<ng-container [ngSwitch]="fr.status">
								<ng-container *ngSwitchCase="PACKAGE_STATUS_TYPES.PREPARE">
									<ng-container *ngIf="!fr.afterClosingDate">
										<p class="p-sm">
											Prepare your Final Report and attach any additional
											documents needed for sending to the lender.
										</p>
										<ui-anchor (click)="gotoFinalReport($event)"
											>Prepare Final Report</ui-anchor
										>
									</ng-container>
									<ng-container *ngIf="fr.afterClosingDate">
										<p class="p-sm">
											Prepare your Final Report and attach any additional
											documents needed for sending to the lender.
										</p>
										<ui-anchor (click)="gotoFinalReport($event)"
											>Review & Send</ui-anchor
										>
									</ng-container>
								</ng-container>

								<ng-container *ngSwitchCase="PACKAGE_STATUS_TYPES.SENDING">
									<p class="p-sm">Your Final Report is on it's way!</p>
									<ui-anchor (click)="gotoHistory($event)"
										>View package status</ui-anchor
									>
								</ng-container>

								<ng-container *ngSwitchCase="PACKAGE_STATUS_TYPES.REVIEW">
									<p class="p-sm">
										Prepare your Final Report and attach any additional
										documents needed for sending to the lender.
									</p>
									<ui-anchor (click)="gotoFinalReport($event)"
										>Review & Send</ui-anchor
									>
								</ng-container>

								<ng-container *ngSwitchCase="PACKAGE_STATUS_TYPES.SENT">
									<p class="p-sm">
										Your Final Report was
										<span class="font-medium"
											>sent on {{ fr.createdAt | closerDate }}</span
										>.
									</p>
									<div class="flex gap-2 items-center">
										<ui-anchor (click)="gotoHistory($event)"
											>View history</ui-anchor
										>
										<span class="p-sm">or</span>
										<ui-anchor (click)="gotoFinalReport($event)"
											>Resend</ui-anchor
										>
									</div>
								</ng-container>

								<ng-container *ngSwitchCase="PACKAGE_STATUS_TYPES.CONFIRMED">
									<p class="p-sm">
										Your Final Report was
										<span class="font-medium"
											>sent on {{ fr.createdAt | closerDate }}</span
										>. It has been received by the lender.
									</p>
									<div class="flex gap-2 items-center">
										<ui-anchor (click)="gotoHistory($event)"
											>View history</ui-anchor
										>
										<span class="p-sm">or</span>
										<ui-anchor (click)="gotoFinalReport($event)"
											>Resend</ui-anchor
										>
									</div>
								</ng-container>
							</ng-container>
						</div>
					</div>
				</ng-container>
			</ng-container>
			<ng-container *ngIf="vm.syncFlowType === SYNC_FLOW_TYPES.EMAIL">
				<div
					class="p-2 rounded-xl bg-white border flex gap-4"
					[ngClass]="vm.hasForms ? 'min-h-56' : 'min-h-52'"
				>
					<div class="basis-4/12 rounded-lg bg-gray-50 p-4 flex items-center">
						<img [src]="'/assets/images/mortgage/final-report-ready.svg'" />
					</div>

					<div class="basis-8/12 p-4 pl-0 flex flex-col gap-4">
						<div class="pb-4 border-b flex gap-4 justify-start">
							<h5 class="h5">Final Report</h5>
						</div>

						<ng-container *ngIf="!vm.mortgage?.isFrEmailSent">
							<p class="p-sm">
								{{ vm.hasForms ? 'Review and download' : 'Complete' }} reporting
								documents and {{ vm.frTransmissionType }} them to
								<ng-container [ngSwitch]="vm.frTransmissionType">
									<span *ngSwitchCase="'fax'" class="font-bold"
										>{{ vm.frTransmissionText }}.</span
									>
									<ng-container *ngSwitchCase="'email'">
										<ng-container
											[ngTemplateOutlet]="emailLink"
											[ngTemplateOutletContext]="{
												link: {
													href: vm.frTransmissionLink,
													text: vm.frTransmissionText,
												},
											}"
											*ngIf="
												vm.mortgage?.lenderContactEmail ||
													vm.primaryLender?.finalReportContact?.email;
												else noEmailSet
											"
										></ng-container>
										<ng-template #noEmailSet>
											<span>
												{{ vm.frTransmissionText }}
											</span>
										</ng-template>
									</ng-container>
								</ng-container>
							</p>
							<ui-anchor (click)="gotoFinalReport($event)" *ngIf="vm.hasForms">
								Review & Download
							</ui-anchor>
						</ng-container>
						<ng-container *ngIf="!!vm.mortgage?.isFrEmailSent">
							<p class="p-sm">
								{{ vm.mortgage?.isFrEmailSent?.confirmedBy?.name }} confirmed
								that the Final Report was {{ vm.frTransmissionTypePastTense }}
								{{ vm.mortgage?.isFrEmailSent?.date | closerDate }}.
							</p>
						</ng-container>

						<app-checkbox
							type="clear"
							label="I have {{
								vm.frTransmissionTypePastTense
							}} the Final Report"
							[ngModel]="!!vm.mortgage?.isFrEmailSent"
							(ngModelChange)="onFrEmailSentChange($event)"
						></app-checkbox>
						<p *ngIf="vm.mortgage?.isFrEmailSent" class="p-xs">
							Confirmed by {{ vm.mortgage?.isFrEmailSent?.confirmedBy?.name }}
							{{ vm.mortgage?.isFrEmailSent?.date | closerDate }}
						</p>
					</div>
				</div>
			</ng-container>
		</ng-container>
	</div>
</ng-container>

<ng-template #emailLink let-link="link">
	<ui-link [href]="link.href" [text]="link.text" target="_blank" />
</ng-template>
